module.exports = __webpack_public_path__ + "icon-256-library-listing-visualisation.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-256-library-listing-visualisation.png
// module id = 638
// module chunks = 11